import { $ } from '@starberry/components';

export default {
  $: 'RoundedCard',
  content: [
    {
      $: 'H5',
      props: {
        as: 'h4',
        mb: 2,
      },
      children: $('constants.translations.valuationCard.VALUE_PROPERTY', 'Value my property'),
    },
    {
      $: 'Text',
      props: {
        color: $('constants.colors.text'),
        fontSize: $('constants.body.bodySize.medium'),
      },
      children: $(
        'constants.translations.valuationCard.VALUE_PROPERTY_TEXT',
        'Book a valuation from one of our property experts.'
      ),
    },
    { $: 'ValuationButton' },
  ],
};
